import React from "react";
import "../pages/style/carrieres.css";
import MapAddresse from "../home/mapAdresse";
import NewsLetter from "../home/newsLetter";
import Footer from "../home/footer";
import SideList from "./../home/SideList";
import Popup from "reactjs-popup";
//import Input from '@material-ui/core/Input';
import BurgerIcon from "../home/BurgerIcon";
import Menu from "../home/Menu";
import Slider from "react-slick";
import { Grid, Row, Col } from "react-flexbox-grid";
import ReactSVG from "react-svg";
//import InputAdornment from '@material-ui/core/InputAdornment';
import { Link } from "react-router-dom";

import object_background from "../assets/header_bg/bgcarriere.png";
import rh from "../assets/carriere/rh.svg";
import web from "../assets/carriere/web.svg";
import marketing from "../assets/carriere/marketing.svg";
import design from "../assets/carriere/design.svg";
//import search from "../assets/carriere/search.svg";

import calendar from "../assets/carriere/calendar.svg";
import map from "../assets/carriere/map.svg";
import temps from "../assets/carriere/temps.svg";
import contrat from "../assets/carriere/contrat.svg";
import axios from "axios";
import { Helmet } from "react-helmet";
import TagManager from "react-gtm-module";

// const tagManagerArgs = {
//   dataLayer: {
//       userProject: 'Chifco_website',
//       page: 'carrières'
//   },
//   dataLayerName: 'PageDataLayer'
// }

const contentStyle = {
  position: "relative",
  background: "linear-gradient(to right, #0c0abe , #07054c)",
  border: "none",
  width: "100%",
  textAlign: "center",
  padding: "0px !important",
  marginLeft: "auto",
  marginRight: "auto",
  marginTop: "80px",
  paddingBottom: "100%",
};

const JobOffer = (props) => (
  <Link
    style={{ textDecoration: "none" }}
    to={"/carrieres/" + props.jobOffer._id}
  >
    <div className="bgPoste">
      <p className="postTitle">{props.jobOffer.Post}</p>
      <br />
      <Grid
        fluid
        style={{ paddingRight: "unset", paddingLeft: "unset", display: "flex" }}
      >
        <Row style={{ width: "100%" }}>
          <Col
            xs={4}
            md={4}
            lg={3}
            style={{ display: "flex", maxWidth: "100%" }}
          >
            <ReactSVG src={temps} alt="" />
            <p className="subtitle" style={{ color: "#f14e3bbd" }}>
              Temps plein
            </p>
          </Col>
          <Col
            xs={8}
            md={8}
            lg={4}
            style={{ display: "flex", maxWidth: "100%" }}
          >
            <ReactSVG src={contrat} alt="" />
            <p
              className="subtitle"
              style={{ color: "rgba(168, 168, 168, 0.81)" }}
            >
              Type de contrat
              <span className="subtitle" style={{ color: "#223b61" }}>
                {props.jobOffer.Type_Contract.name_Contract}
              </span>{" "}
            </p>
          </Col>
          <Col
            xs={4}
            md={4}
            lg={2}
            style={{ display: "flex", maxWidth: "100%" }}
          >
            <ReactSVG alt="" src={map} />
            <p
              className="subtitle"
              style={{ color: "rgba(168, 168, 168, 0.81)" }}
            >
              {props.jobOffer.location}
            </p>
          </Col>
          <Col
            xs={8}
            md={8}
            lg={3}
            style={{ display: "flex", maxWidth: "100%" }}
          >
            <ReactSVG src={calendar} alt="" />
            <p
              className="subtitle"
              style={{ color: "rgba(168, 168, 168, 0.81)" }}
            >
              {props.jobOffer.date.substring(0, 10)}
            </p>
          </Col>
        </Row>
      </Grid>
    </div>
  </Link>
);

const InternShipOffer = (props) => (
  <Link
    style={{ textDecoration: "none" }}
    to={"/internShip/" + props.internShipOffer._id}
  >
    <div className="bgPoste">
      <p className="postTitle">{props.internShipOffer.Post}</p>
      <br />
      <Grid
        fluid
        style={{ paddingRight: "unset", paddingLeft: "unset", display: "flex" }}
      >
        <Row style={{ width: "100%" }}>
          <Col
            xs={4}
            md={4}
            lg={3}
            style={{ display: "flex", maxWidth: "100%" }}
          >
            <ReactSVG src={temps} alt="" />
            <p className="subtitle" style={{ color: "#f14e3bbd" }}>
              Temps plein
            </p>
          </Col>
          <Col
            xs={8}
            md={8}
            lg={4}
            style={{ display: "flex", maxWidth: "100%" }}
          >
            <ReactSVG src={contrat} alt="" />
            <p
              className="subtitle"
              style={{ color: "rgba(168, 168, 168, 0.81)" }}
            >
              Type de contrat
              <span className="subtitle" style={{ color: "#223b61" }}>
                {props.internShipOffer.Type_Contract.name_Contract}
              </span>{" "}
            </p>
          </Col>
          <Col
            xs={4}
            md={4}
            lg={2}
            style={{ display: "flex", maxWidth: "100%" }}
          >
            <ReactSVG alt="" src={map} />
            <p
              className="subtitle"
              style={{ color: "rgba(168, 168, 168, 0.81)" }}
            >
              {props.internShipOffer.location}
            </p>
          </Col>
          <Col
            xs={8}
            md={8}
            lg={3}
            style={{ display: "flex", maxWidth: "100%" }}
          >
            <ReactSVG src={calendar} alt="" />
            <p
              className="subtitle"
              style={{ color: "rgba(168, 168, 168, 0.81)" }}
            >
              {props.internShipOffer.date.substring(0, 10)}
            </p>
          </Col>
        </Row>
      </Grid>
    </div>
  </Link>
);

const Category = (props) => (
  <div className="bgCategory">
    <div style={{ height: "85px" }}>
      <ReactSVG
        src={
          `${process.env.REACT_APP_SERVER}` + "/images/" + props.category.Icon
        }
        svgStyle={{ width: "25%", marginTop: "13px", marginBottom: "5px" }}
      />
    </div>
    <p className="txtCategory">{props.category.name_Catg}</p>
    <p
      className="txtCategory"
      style={{ color: "#a8a8a8", paddingBottom: "7px" }}
    >
      ( {props.category.Nbr_Position} open positions )
    </p>
  </div>
);

class Carrieres extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      JobOffers: [],
      InternShip_Offer: [],
      Categories: [],
    };
  }
  componentDidMount() {
    window.scrollTo({ top: 0, behavior: "smooth" });
    axios
      .get(`${process.env.REACT_APP_SERVER}` + "/JobOffers/active")
      .then((response) => {
        this.setState({ JobOffers: response.data });
      })
      .catch((error) => {
        console.log(error);
      });
    axios
      .get(`${process.env.REACT_APP_SERVER}` + "/InternShip_Offer/active")
      .then((response) => {
        this.setState({ InternShip_Offer: response.data });
      })
      .catch((error) => {
        console.log(error);
      });
    axios
      .get(`${process.env.REACT_APP_SERVER}` + "/Categories")
      .then((response) => {
        this.setState({ Categories: response.data });
      })
      .catch((error) => {
        console.log(error);
      });
  }

  OffersList() {
    if (this.state.JobOffers.length > 0) {
      return this.state.JobOffers.map((currentjobOffer) => {
        return (
          <JobOffer jobOffer={currentjobOffer} key={currentjobOffer._id} />
        );
      });
    } else {
      return <h4 className="notfound"> Désolé, pas de postes disponibles pour le moment </h4>;
    }
  }
  InternShipList() {
    if (this.state.InternShip_Offer.length > 0) {
      return this.state.InternShip_Offer.map((currentinternShipOffer) => {
        return (
          <InternShipOffer
            internShipOffer={currentinternShipOffer}
            key={currentinternShipOffer._id}
          />
        );
      });
    } else {
      return <h4 className="notfound"> Désolé, pas de stages disponibles pour le moment </h4>;
    }
  }
  CategoryList() {
    return this.state.Categories.map((currentcategory) => {
      return <Category category={currentcategory} key={currentcategory._id} />;
    });
  }
  render() {
    var settings = {
      dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: 4,
      slidesToScroll: 4,
      arrows: false,
      responsive: [
        {
          breakpoint: 1100,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
          },
        },

        {
          breakpoint: 580,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    };

    //TagManager.dataLayer(tagManagerArgs)

    return (
      <div>
        <Helmet>
          <meta charSet="utf-8" />
          <title>Carrières</title>
          <link
            rel="canonical"
            href={
              //"https://chifcositev2.chifco.com" +
              process.env.REACT_APP_CLIENT + "/carrieres"
            }
          />
        </Helmet>
        <div className="banniereSlidCarriere">
          {/*Menu horizontal Web*/}
          <div className="menu-horizontal">
            <Menu />
          </div>
          {/*Menu Responsive Popup*/}
          <div className="menuMobile">
            <Popup
              modal
              overlayStyle={{
                background: "linear-gradient(to right, #0c0abe , #07054c)",
                width: "100%",
              }}
              contentStyle={contentStyle}
              closeOnDocumentClick={false}
              trigger={(open) => <BurgerIcon open={open} />}
            >
              <SideList />
            </Popup>
          </div>

          <div className="textBanniereCarriere">
            <h1 className="sliderTitleCarriere">
              REJOIGNEZ
              <br />
              <b style={{ color: "#ffd904" }}>NOTRE ÉQUIPE !</b>
            </h1>
            <div className="imgCarrierebg">
              <img
                className="imageBaniereCarriere"
                src={object_background}
                alt=""
              />
            </div>
          </div>
        </div>
        <div style={{ backgroundColor: "white" }}>
          <div style={{ padding: "10px", textAlign: "center" }}>
            <h1 className="TitleCategorie">CATÉGORIES</h1>
          </div>
          <div
            className="flex-containerDiv"
            style={{
              marginRight: "auto",
              marginLeft: "auto",
              marginTop: "15px",
              marginBottom: "80px",
            }}
          >
            <Slider {...settings}>{this.CategoryList()}</Slider>
            <Grid
              fluid
              style={{
                paddingRight: "unset",
                paddingLeft: "unset",
                marginTop: "20px",
              }}
            >
              <Row>
                {/*   <Col xs={12} md={8} lg={9} className="colwidth"> */}
                <Col xs={12} md={12} lg={12} style={{ maxWidth: "100%" }}>
                  
            <Row> <Col xs={12} md={12}><h1 className="TitleCategorie">POSTES DISPONIBLES  </h1> </Col>
            {/* <Col xs={12} md={8}> { true ? <h4 className="notfound"> Désolé, nous n'avons aucun post disponible pour le moment </h4> : "" } </Col> */}
            </Row> 
                  {this.OffersList()}
                  
                    <h1 className="TitleCategorie">STAGES DISPONIBLES</h1>
                 
                  {this.InternShipList()}
                </Col>

                {/* 
                                <Col xs={12} md={4} lg={3} className="divCol">
                                    <h1 className="TitleCategorie" style={{fontSize: "medium"}}>Recherche</h1>
                                    <Input style={{display: "flex"}}
                                    placeholder="Mot clés"
                                    endAdornment={
                                        <InputAdornment position="end">
                                        <img src={search} alt="" style={{width: "6%",position: "absolute",right: "10px"}}/>
                                        </InputAdornment>
                                      }
                                  
                                    />
                                    <h1 className="TitleCategorie" style={{fontSize: "medium"}}>Catégories</h1>
                                    <div className="bgCatego">
                                      <p className="filterTitle">Développement Web <span style={{float: "right"}}>12</span></p>
                                      <div className="Line"></div>
                                      <p className="filterTitle">Développement Mobile <span style={{float: "right"}}>2</span></p>
                                      <div className="Line"></div>
                                      <p className="filterTitle">Relation Client <span style={{float: "right"}}>3</span></p>  
                                      <div className="Line"></div>
                                      <p className="filterTitle">Marketing <span style={{float: "right"}}>6</span></p>
                                      <div className="Line"></div>
                                      <p className="filterTitle">Sales Web <span style={{float: "right"}}>7</span></p>
                                      <div className="Line"></div>
                                      <p className="filterTitle">WebDesigner <span style={{float: "right"}}>9</span></p>  
                                      <div className="Line"></div>
                                      <p className="filterTitle">Ressources Humaines <span style={{float: "right"}}>3</span></p>
                                      <div className="Line"></div>
                                      <p className="filterTitle">Autres<span style={{float: "right"}}>0</span></p>
                                    </div>
                                
                                </Col> 
                                    */}
              </Row>
            </Grid>
          </div>
        </div>

        <MapAddresse />
        <NewsLetter />
        <Footer />
      </div>
    );
  }
}
export default Carrieres;



// WEBPACK FOOTER //
// ./src/pages/carrieres.js